// 상품 상세페이지 내용 업데이트 250103 alex (i18n 적용) start
if (window.location.pathname.includes('/products/')) {
  document.addEventListener('DOMContentLoaded', function () {
    console.log("DOM is fully loaded and parsed");
    const DBG = true;
    function dlog(...args){ if(DBG) console.log(...args); }
    dlog('[DBG] productData exists?', !!window.productData);
    dlog('[DBG] variants length:', window.productData?.variants?.length);
    dlog('[DBG] current form variant id:', document.querySelector('form[action*="/cart/add"] input[name="id"]')?.value);
    dlog('[DBG] container at load:', document.getElementById('variant-info-container'));


    if (!window.productData) {
      console.error("Error: window.productData가 정의되지 않았습니다.");
      return;
    }

    const variantRadios = document.querySelector('variant-radios, variant-selects');
    const variantInfoContainer = document.getElementById('variant-info-container');
    const hasVariants = !!variantRadios;

    if (!variantInfoContainer) {
      console.error("Variant info container element not found.");
      return;
    }

    /* ====== 로케일 & 번역 테이블 ====== */
    function resolveLocale() {
      const raw =
        (window.productData && window.productData.locale) ||
        document.documentElement.getAttribute('lang') ||
        'ko';
      const lc = raw.toLowerCase();
      if (lc.startsWith('ja')) return 'ja';
      if (lc.startsWith('en')) return 'en';
      return 'ko';
    }
    const LC = resolveLocale();

    const I18N = {
      ko: {
        BASIC: "상품 기본 정보",   
        CODE:"제품코드", LEAD:"배송기간", STOCK:"재고수량", METHOD:"배송방식",
        SHIPFEE:"배송비용", TAX:"관부가세", QUALITY:"품질",
        ETA_D:function(s){ return '오늘 주문할 경우 ' + s + ' 이내 도착 예상'; },
        ETA_M:function(s){ return '오늘 주문할 경우 ' + s + ' 도착 예상'; },
        STOCK_QTY:function(n){ return '재고 ' + n + '개 보유중'; },
        STOCK_OVER:function(n){ return '해외 판매자 ' + n + '개 보유중'; },
        SOLD_OUT:"품절",
        METHOD_DOMESTIC:"국내 택배/설치(제품별 상이)",
        METHOD_HIGHHOME:"주문 확인 후 1주일 이내 국제택배 발송(평균 2~3주)",
        METHOD_MTO_SEA:"제품 제작(최소 3개월 이상) -> 해상운송 및 국내배송(평균 3개월)",
        METHOD_MTO_COUR:"제품 제작(최소 3개월 이상) -> 국제택배 발송(평균 1개월)",
        METHOD_OS_SEA:"현지 재고 구매(평균 2주) -> 해상운송 및 국내배송(평균 3개월)",
        METHOD_OS_COUR:"현지 재고 구매(평균 1개월) -> 국제택배 발송(평균 1개월)",
        FEE_COLLECT:"착불",
        FEE_CHECK:"무료배송",
        DUTY_CHECK:"관부가세 포함 / 추가비용 없음",
        NO_STOCK_MTO:"국내 재고 없음, 주문 후 제작 진행",
        CONTACT:"위 버튼을 클릭하여 제품을 문의해주시면 친절히 상담 도와드리겠습니다.",
        // ▼ 제품 규격(마켓별)
        SPECS: "제품 규격",
        DIM_LABEL: "사이즈 (W × D × H)",
        WEIGHT_LABEL: "무게"
      },
      ja: {
        BASIC: "商品基本情報",
        CODE:"製品コード", LEAD:"配送期間", STOCK:"在庫数", METHOD:"配送方法",
        SHIPFEE:"配送料", TAX:"関税・消費税", QUALITY:"品質",
        ETA_D:function(s){ return '本日ご注文の場合、' + s + ' 以内にお届け予定'; },
        ETA_M:function(s){ return '本日ご注文の場合、' + s + ' ごろお届け予定'; },
        STOCK_QTY:function(n){ return '在庫 ' + n + ' 点あります'; },
        STOCK_OVER:function(n){ return '海外セラー在庫 ' + n + ' 点'; },
        SOLD_OUT:"在庫切れ",
        METHOD_DOMESTIC:"国内宅配／設置（商品により異なります）",
        METHOD_HIGHHOME:"ご注文確認後1週間以内に国際宅配で発送（平均2～3週間）",
        METHOD_MTO_SEA:"製作（最低3か月～）→ 海上輸送・国内配送（平均3か月）",
        METHOD_MTO_COUR:"製作（最低3か月～）→ 国際宅配発送（平均1か月）",
        METHOD_OS_SEA:"現地在庫購入（平均2週間）→ 海上輸送・国内配送（平均3か月）",
        METHOD_OS_COUR:"現地在庫購入（平均1か月）→ 国際宅配発送（平均1か月）",
        FEE_COLLECT:"着払い",
        FEE_CHECK:"ご注文／お支払い時に確認可能",
        DUTY_CHECK:"ご注文／お支払い時に確認可能",
        NO_STOCK_MTO:"国内在庫なし、受注生産にて対応",
        CONTACT:"上のボタンよりお問い合わせいただければ、丁寧にご案内いたします。",
        // ▼ 製品仕様(마켓별)
        SPECS: "製品仕様",
        DIM_LABEL: "サイズ（W × D × H）",
        WEIGHT_LABEL: "重量"
      },
      en: {
        BASIC: "Product Details",
        CODE:"Product Code", LEAD:"Lead Time", STOCK:"Stock", METHOD:"Shipping Method",
        SHIPFEE:"Shipping Fee", TAX:"Duties & Taxes", QUALITY:"Quality",
        ETA_D:function(s){ return 'If you order today, estimated delivery within ' + s; },
        ETA_M:function(s){ return 'If you order today, ETA around ' + s; },
        STOCK_QTY:function(n){ return 'In stock: ' + n; },
        STOCK_OVER:function(n){ return 'Overseas seller stock: ' + n; },
        SOLD_OUT:"Sold out",
        METHOD_DOMESTIC:"Domestic courier/installation (varies by product)",
        METHOD_HIGHHOME:"Ships via international courier within 1 week after order confirmation (avg. 2–3 weeks)",
        METHOD_MTO_SEA:"Made to order (min. 3+ months) → Sea freight & domestic delivery (avg. 3 months)",
        METHOD_MTO_COUR:"Made to order (min. 3+ months) → International courier (avg. 1 month)",
        METHOD_OS_SEA:"Purchase local stock (avg. 2 weeks) → Sea freight & domestic delivery (avg. 3 months)",
        METHOD_OS_COUR:"Purchase local stock (avg. 1 month) → International courier (avg. 1 month)",
        FEE_COLLECT:"Freight collect",
        FEE_CHECK:"Shown at checkout",
        DUTY_CHECK:"Shown at checkout",
        NO_STOCK_MTO:"No domestic stock; produced after order",
        CONTACT:"Click the button above to contact us — we’ll be happy to assist.",
        // ▼ Specifications(마켓별)
        SPECS: "Specifications",
        DIM_LABEL: "Dimensions (W × D × H)",
        WEIGHT_LABEL: "Weight"
      }
    };

    const T = I18N[LC] || I18N.ko;

    function formatYearMonth(dateObj) {
      const y = dateObj.getFullYear();
      const m = dateObj.getMonth() + 1;
      if (LC === 'ja') return `${y}年 ${m}月`;
      if (LC === 'en') {
        const mon = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
        return `${mon[m-1]} ${y}`;
      }
      return `${y}년 ${m}월`;
    }

    function calculateFutureDate(monthsToAdd) {
      const currentDate = new Date();
      currentDate.setMonth(currentDate.getMonth() + monthsToAdd);
      return formatYearMonth(currentDate);
    }

    function calculateDaysAhead(daysToAdd) {
      const currentDate = new Date();
      currentDate.setDate(currentDate.getDate() + daysToAdd);
      const locale = LC === 'ja' ? 'ja-JP' : (LC === 'en' ? 'en-US' : 'ko-KR');
      return currentDate.toLocaleDateString(locale);
    }

    // 숫자/단위 변환 헬퍼
    function metaNumber(field) {
      if (field == null) return null;
      if (typeof field === 'object' && field.value != null) {
        const n = parseFloat(field.value);
        return isNaN(n) ? null : n;
      }
      const n = parseFloat(field);
      return isNaN(n) ? null : n;
    }

    function gramsToKg(g) {
      return g / 1000;
    }

    function gramsToLb(g) {
      return g / 453.59237;
    }

    function cmToInch(cm) {
      return cm / 2.54;
    }

    function formatNum(value, decimals) {
      if (value == null) return null;
      const factor = Math.pow(10, decimals);
      return (Math.round(value * factor) / factor).toFixed(decimals);
    }

    function injectVariantInfoStyles() {
      if (document.getElementById('variant-info-style')) return;
      const style = document.createElement('style');
      style.id = 'variant-info-style';
      style.textContent = `
        /* 공통 컨테이너: 전체 여백 최소화 + 기본 폰트 */
        #variant-info-container {
          padding: 8px 0 0;
          font-size: 18px; /* 기본(모바일 포함) 18px */
          max-width: 100%;          /* 컨테이너가 화면을 넘지 않도록 */
          overflow-x: hidden;       /* 가로 스크롤 강제 차단 */
        }

        /* 내부 텍스트는 무조건 줄바꿈되도록 */
        #variant-info-container *,
        #variant-info-container th,
        #variant-info-container td {
          box-sizing: border-box;
          word-break: break-word;
          overflow-wrap: anywhere;
        }
        /* "상품 기본 정보" / "제품 규격" 섹션 제목 */
        #variant-info-container .variant-basic-heading,
        #variant-info-container .variant-specs-heading {
          max-width: 820px;
          margin: 0 auto 6px auto;
          font-size: 0.95em;
          font-weight: 700;
          letter-spacing: 0.04em;
          color: #444;
          border-bottom: 1px solid #e5e5e5;
          padding-bottom: 4px;
        }

        /* 메인 정보 테이블 & 제품 규격 테이블 공통 설정 */
        #variant-info-container .variant-info-table,
        #variant-info-container .variant-specs-table {
          width: 100%;
          max-width: 820px;        /* 너무 넓지 않게 적당히 줄이기 */
          margin: 0 auto 10px auto;/* 위아래 살짝만 간격 */
          border-collapse: collapse;
          border-radius: 10px;
          overflow: hidden;
          border: 1px solid #e2e2e2;   /* 모던한 얇은 테두리 */
          background-color: #ffffff;   /* ✅ 회색 배경 느낌 제거 */
        }

        #variant-info-container .variant-info-table th,
        #variant-info-container .variant-info-table td,
        #variant-info-container .variant-specs-table th,
        #variant-info-container .variant-specs-table td {
          padding: 11px 16px;
          vertical-align: top;
          font-size: 1em;        /* 컨테이너 폰트(18/20px) 따라감 */
          line-height: 1.6;
          border-bottom: 1px solid #f0f0f0;  /* 행 구분선만 가볍게 */
        }

        /* 마지막 행은 아래 테두리 제거 */
        #variant-info-container .variant-info-table tr:last-child th,
        #variant-info-container .variant-info-table tr:last-child td,
        #variant-info-container .variant-specs-table tr:last-child th,
        #variant-info-container .variant-specs-table tr:last-child td {
          border-bottom: none;
        }

        #variant-info-container .variant-info-table th,
        #variant-info-container .variant-specs-table th {
          white-space: nowrap;
          text-align: left;
          font-weight: 600;
          color: #222;
          width: 190px;
          border-right: 1px solid #f0f0f0; /* 좌우 컬럼 분리만 */
          background-color: #ffffff;       /* ✅ 헤더 회색 제거 */
        }

        #variant-info-container .variant-info-table td,
        #variant-info-container .variant-specs-table td {
          word-break: break-word;
          overflow-wrap: anywhere;
          color: #111;
          background-color: #ffffff;       /* ✅ 줄무늬 배경 제거 */
        }

        /* 제품 규격 블럭 래퍼 (상품 기본 정보와 간격) */
        #variant-info-container .variant-specs-wrapper {
          margin-top: 20px;
        }

        /* 모바일 (<=768px) : 폰트 18px 유지, 여백만 축소 */
        @media (max-width: 768px) {
          #variant-info-container {
            padding: 4px 0 0;
            font-size: 18px; /* 모바일은 18px 고정 */
            max-width: 100%;
          }

          /* 모바일에서 테이블은 화면 폭에 딱 맞게 */
          #variant-info-container .variant-info-table,
          #variant-info-container .variant-specs-table {
            width: 100%;
            max-width: 100%;
            table-layout: fixed;          /* 셀 폭을 강제로 화면 안으로 */
          }

          #variant-info-container .variant-info-table th,
          #variant-info-container .variant-info-table td,
          #variant-info-container .variant-specs-table th,
          #variant-info-container .variant-specs-table td {
            padding: 9px 12px;
          }

          #variant-info-container .variant-info-table th,
          #variant-info-container .variant-specs-table th {
            width: 35%;                   /* 너무 넓지 않게 비율로 */
            white-space: normal;          /* 모바일에서는 제목도 줄바꿈 허용 */
          }

          #variant-info-container .variant-basic-heading,
          #variant-info-container .variant-specs-heading {
            padding: 0 12px 4px;
            max-width: 100%;
            word-break: break-word;
            overflow-wrap: anywhere;
          }
        }

        /* 데스크탑 (>=1024px) : 폰트 20px */
        @media (min-width: 1024px) {
          #variant-info-container {
            font-size: 20px;
          }
        }
      `;
      document.head.appendChild(style);
    }


    injectVariantInfoStyles();
    

        // ====== Additional Finish (Upholstery / Top finish 등) 스와치 컨트롤러 ======
    const upholsteryController = (function buildUpholsteryController() {
      const root = document.querySelector('[data-brand-down][id^="upholstery-swatch-root"]');
      if (!root) return null;

      const productForm = document.querySelector('form[action*="/cart/add"]');
      if (!productForm) return null;

      function ensurePropertyInputByKey(key) {
        var productForm = document.querySelector('form[action*="/cart/add"]');
        if (!productForm) return null;

        var name = `properties[${key}]`;
        var selector = `input[name="${name}"]`;

        var input = productForm.querySelector(selector);
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = name;
          productForm.appendChild(input);
        }
        return input;
      }


        // 🔁 main-product.liquid에서 만든 것과 동일한 key 사용
      const propLine  = ensurePropertyInputByKey('Finish line');
      const propColor = ensurePropertyInputByKey('Color name');


      function clearUpholsteryProps() {
        propLine.value  = '';
        propColor.value = '';
        propLine.removeAttribute('name');
        propColor.removeAttribute('name');
      }

      function applyUpholsteryProps(line, color) {
        if (line && color) {
          propLine.value  = line;
          propColor.value = color;
          propLine.name   = 'properties[Finish line]';
          propColor.name  = 'properties[Color name]';
        } else {
          clearUpholsteryProps();
        }
      }

      // 옵션별 블록 (Upholstery Grade / Top finish 등)
      let blocks = Array.prototype.slice.call(
        root.querySelectorAll('[data-finish-category-root="true"]')
      );


      // ▼ fallback: 아직 data-finish-category-root 블록을 안 만들어뒀으면,
      //   root 자체를 단일 블록으로 간주
      if (!blocks.length) {
        blocks = [root];
        root.style.display = ''; // 혹시 예전에 display:none 걸려 있으면 풀어주기
      }

      const categoryControllers = blocks.map(function (block, blockIndex) {
        const optionIndex  = parseInt(block.dataset.finishOptionIndex, 10) || 0;
        const lineContainer   = block.querySelector('.upholstery-lines');
        const detailRoot      = block.querySelector('.upholstery-swatch-detail');
        const lineDescHolder  = block.querySelector('[data-line-description-holder]');

        const swatchButtons = Array.prototype.slice.call(
          block.querySelectorAll('.upholstery-swatch')
        );


        swatchButtons.forEach(function (btn, idx) {

        });

        // gradeCode → line → [buttons]
        const gradeMap = {};
        swatchButtons.forEach(function (btn) {
          const gradeCode = (btn.dataset.gradeCode || '').trim();
          const line      = (btn.dataset.line || '').trim();
          if (!gradeCode) return;

          if (!gradeMap[gradeCode]) gradeMap[gradeCode] = {};
          if (!gradeMap[gradeCode][line]) gradeMap[gradeCode][line] = [];
          gradeMap[gradeCode][line].push(btn);
        });

        function clearLineButtons() {
          if (lineContainer) lineContainer.innerHTML = '';
        }

        function resetSwatches() {
          swatchButtons.forEach(function (btn) {
            btn.classList.remove('is-selected');
            btn.style.display = 'none';
          });

          if (detailRoot) {
            detailRoot.innerHTML = '';
          }
          if (lineDescHolder) {
            lineDescHolder.textContent = '';
            lineDescHolder.style.display = 'none';
          }

          clearUpholsteryProps();
        }

        function selectLine(gradeCode, line, list) {
          Array.prototype.forEach.call(
            lineContainer.querySelectorAll('.upholstery-line-button'),
            function (btn) {
              btn.classList.toggle('is-selected', btn.dataset.line === line);
            }
          );

          resetSwatches();

          if (lineDescHolder) {
            const desc = list.length ? (list[0].dataset.lineDesc || '') : '';
            if (desc) {
              lineDescHolder.textContent = desc;
              lineDescHolder.style.display = '';
            } else {
              lineDescHolder.textContent = '';
              lineDescHolder.style.display = 'none';
            }
          }

          list.forEach(function (btn) {
            btn.style.display = '';

            btn.onclick = function () {
              list.forEach(function (b) { b.classList.remove('is-selected'); });
              btn.classList.add('is-selected');

              const lineLabel = line || '';
              const colorName = btn.dataset.name || '';
              const colorCode = btn.dataset.code ? ` (${btn.dataset.code})` : '';

              applyUpholsteryProps(lineLabel, `${colorName}${colorCode}`);

              if (detailRoot) {
                const img = btn.querySelector('img');
                const imgHtml = img ? img.outerHTML : '';

                detailRoot.innerHTML = `
                  <div class="upholstery-swatch-detail__inner">
                    <div class="upholstery-swatch-detail__image-wrap">
                      ${imgHtml}
                    </div>
                    <div class="upholstery-swatch-detail__texts">
                      ${lineLabel
                        ? `<div class="upholstery-swatch-detail__line">${lineLabel}</div>`
                        : ''
                      }
                      <div class="upholstery-swatch-detail__name">
                        ${colorName}${colorCode}
                      </div>
                    </div>
                  </div>
                `;
              }
            };
          });
        }

        function updateForGradeCode(gradeCode) {
          clearLineButtons();
          resetSwatches();

          if (!gradeCode || !gradeMap[gradeCode]) {
            block.style.display = 'none';
            return;
          }

          block.style.display = '';

          const lines = Object.keys(gradeMap[gradeCode]);

          lines.forEach(function (line) {
            const btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'upholstery-line-button';
            btn.dataset.line = line;
            btn.textContent = line || '기본 라인';

            const list = gradeMap[gradeCode][line];

            btn.addEventListener('click', function () {
              selectLine(gradeCode, line, list);
            });

            lineContainer.appendChild(btn);
          });
        }

        function updateForVariant(variant) {
          if (!variant) return;
          const optionsArr = [variant.option1, variant.option2, variant.option3];
          const gradeCode = (optionsArr[optionIndex] || '').trim();
          updateForGradeCode(gradeCode);
        }

        return {
          updateForVariant
        };
      });

      function updateForVariant(variant) {


        categoryControllers.forEach(function (cc, idx) {
          cc.updateForVariant(variant);
        });
      }

      return {
        updateForVariant
      };
    })();





    // 변형 정보 업데이트 함수
    function updateVariantInfo(selectedVariant) {
      dlog('[DBG] updateVariantInfo called');
      dlog('[DBG] container now:', document.getElementById('variant-info-container'));
      dlog('[DBG] selectedVariant in param:', selectedVariant?.id, selectedVariant?.title);
      dlog('[DBG] form variant id now:', document.querySelector('form[action*="/cart/add"] input[name="id"]')?.value);

      const variantInfoContainer = document.getElementById('variant-info-container');
      if (!variantInfoContainer) return;
      let htmlContent =
        `<div class="variant-basic-heading">${T.BASIC}</div>` +  // ✅ 상품 기본 정보 제목
        '<table class="variant-info-table" border="1" cellpadding="8" cellspacing="0">';
      let specsHtml = ''; // 제품 규격(사이즈/무게) 테이블 HTML

      htmlContent += `
        <tr>
          <th style="white-space: nowrap;">${T.CODE}</th>
          <td>${window.productData.id}</td>
        </tr>`;

      if (!window.productData.metafields || !window.productData.metafields.custom) {
        console.error("Error: productData의 메타필드가 정의되지 않았습니다.");
        return;
      }

      const { inventory_type, delivery_method, seller} = window.productData.metafields.custom;

      if (!selectedVariant) {
        selectedVariant = window.productData.variants[0];
      }

      // 국내재고 기준: seller가 'CDFBROS' 인 경우
      if (typeof seller === 'string' && seller.trim().toUpperCase() === 'CDFBROS') {
        htmlContent += `
          <tr>
            <th style="white-space: nowrap;">${T.LEAD}</th>
            <td>${T.ETA_D(calculateDaysAhead(14))}</td>
          </tr>`;

        if (selectedVariant && selectedVariant.inventory_quantity > 0) {
          htmlContent += `
            <tr>
              <th style="white-space: nowrap;">${T.STOCK}</th>
              <td>${T.STOCK_QTY(selectedVariant.inventory_quantity)}</td>
            </tr>`;
        } else {
          htmlContent += `<tr><th style="white-space: nowrap;">${T.STOCK}</th><td>${T.SOLD_OUT}</td></tr>`;
        }

        htmlContent += `
          <tr>
            <th style="white-space: nowrap;">${T.METHOD}</th>
            <td>${T.METHOD_DOMESTIC}</td>
          </tr>`;

        if (delivery_method && delivery_method.includes('배송비 착불')) {
          htmlContent += `<tr><th style="white-space: nowrap;">${T.SHIPFEE}</th><td>${T.FEE_COLLECT}</td></tr>`;
        } else {
          htmlContent += `<tr><th style="white-space: nowrap;">${T.SHIPFEE}</th><td>${T.FEE_CHECK}</td></tr>`;
        }

      /* ▼▼▼ HIGHHOME 분기 ▼▼▼ */
      } else if (typeof seller === 'string' && seller.trim().toUpperCase() === 'HIGHHOME') {
        htmlContent += `
          <tr>
            <th style="white-space: nowrap;">${T.LEAD}</th>
            <td>${T.ETA_D(calculateDaysAhead(21))}</td>
          </tr>`;

        if (selectedVariant && selectedVariant.inventory_quantity > 0) {
          htmlContent += `
            <tr>
              <th style="white-space: nowrap;">${T.STOCK}</th>
              <td>${T.STOCK_QTY(selectedVariant.inventory_quantity)}</td>
            </tr>`;
        } else {
          htmlContent += `<tr><th style="white-space: nowrap;">${T.STOCK}</th><td>${T.SOLD_OUT}</td></tr>`;
        }

        htmlContent += `
          <tr>
            <th style="white-space: nowrap;">${T.METHOD}</th>
            <td>${T.METHOD_HIGHHOME}</td>
          </tr>`;

        if (delivery_method && delivery_method.includes('배송비 착불')) {
          htmlContent += `<tr><th style="white-space: nowrap;">${T.SHIPFEE}</th><td>${T.FEE_COLLECT}</td></tr>`;
        } else {
          htmlContent += `<tr><th style="white-space: nowrap;">${T.SHIPFEE}</th><td>${T.FEE_CHECK}</td></tr>`;
        }
      /* ▲▲▲ HIGHHOME 끝 ▲▲▲ */

      } else {
        if (delivery_method && delivery_method.includes('주문제작 + 해상')) {
          htmlContent += `
            <tr>
              <th style="white-space: nowrap;">${T.LEAD}</th>
              <td>${T.ETA_M(calculateFutureDate(6))}</td>
            </tr>
            <tr>
              <th style="white-space: nowrap;">${T.STOCK}</th>
              <td>${T.NO_STOCK_MTO}</td>
            </tr>
            <tr>
              <th style="white-space: nowrap;">${T.METHOD}</th>
              <td>${T.METHOD_MTO_SEA}</td>
            </tr>
            <tr>
              <th style="white-space: nowrap;">${T.SHIPFEE}</th>
              <td>${T.FEE_CHECK}</td>
            </tr>
            <tr>
              <th style="white-space: nowrap;">${T.TAX}</th>
              <td>${T.DUTY_CHECK}</td>
            </tr>`;
        } else if (delivery_method && delivery_method.includes('주문제작 + 택배')) {
          htmlContent += `
            <tr>
              <th style="white-space: nowrap;">${T.LEAD}</th>
              <td>${T.ETA_M(calculateFutureDate(4))}</td>
            </tr>
            <tr>
              <th style="white-space: nowrap;">${T.STOCK}</th>
              <td>${T.NO_STOCK_MTO}</td>
            </tr>
            <tr>
              <th style="white-space: nowrap;">${T.METHOD}</th>
              <td>${T.METHOD_MTO_COUR}</td>
            </tr>
            <tr>
              <th style="white-space: nowrap;">${T.SHIPFEE}</th>
              <td>${T.FEE_CHECK}</td>
            </tr>
            <tr>
              <th style="white-space: nowrap;">${T.TAX}</th>
              <td>${T.DUTY_CHECK}</td>
            </tr>`;
        }
        else if (delivery_method && delivery_method.includes('해외재고 + 해상')) {
          htmlContent += `
          <tr>
            <th style="white-space: nowrap;">${T.LEAD}</th>
            <td>${T.ETA_M(calculateFutureDate(4))}</td>
          </tr>`;

          if (selectedVariant && selectedVariant.inventory_quantity > 0) {
            htmlContent += `
              <tr>
                <th style="white-space: nowrap;">${T.STOCK}</th>
                <td>${T.STOCK_OVER(selectedVariant.inventory_quantity)}</td>
              </tr>`;
          } else {
            htmlContent += `<tr><th style="white-space: nowrap;">${T.STOCK}</th><td>${T.SOLD_OUT}</td></tr>`;
          }

          htmlContent += `
            <tr>
              <th style="white-space: nowrap;">${T.METHOD}</th>
              <td>${T.METHOD_OS_SEA}</td>
            </tr>
            <tr>
              <th style="white-space: nowrap;">${T.SHIPFEE}</th>
              <td>${T.FEE_CHECK}</td>
            </tr>
            <tr>
              <th style="white-space: nowrap;">${T.TAX}</th>
              <td>${T.DUTY_CHECK}</td>
            </tr>`;
        } else if (delivery_method && delivery_method.includes('해외재고 + 택배')) {
          htmlContent += `
          <tr>
            <th style="white-space: nowrap;">${T.LEAD}</th>
            <td>${T.ETA_D(calculateDaysAhead(60))}</td>
          </tr>`;

          if (selectedVariant && selectedVariant.inventory_quantity > 0) {
            htmlContent += `
              <tr>
                <th style="white-space: nowrap;">${T.STOCK}</th>
                <td>${T.STOCK_OVER(selectedVariant.inventory_quantity)}</td>
              </tr>`;
          } else {
            htmlContent += `<tr><th style="white-space: nowrap;">${T.STOCK}</th><td>${T.SOLD_OUT}</td></tr>`;
          }

          htmlContent += `
            <tr>
              <th style="white-space: nowrap;">${T.METHOD}</th>
              <td>${T.METHOD_OS_COUR}</td>
            </tr>
            <tr>
              <th style="white-space: nowrap;">${T.SHIPFEE}</th>
              <td>${T.FEE_CHECK}</td>
            </tr>
            <tr>
              <th style="white-space: nowrap;">${T.TAX}</th>
              <td>${T.DUTY_CHECK}</td>
            </tr>`;
        } else {
          // inventory_type이나 delivery_method가 조건에 맞지 않을 경우
          htmlContent += `
          <tr>
            <th colspan="2">${T.CONTACT}</th>
          </tr>`;
        }
      }

      // 변형의 메타필드 확인 (품질 + 제품 규격 테이블)
      if (selectedVariant && selectedVariant.metafields && selectedVariant.metafields.custom) {
        const {
          product_quality,
          weight,
          depth,
          width,
          height
        } = selectedVariant.metafields.custom;

        // 숫자 메타필드 파싱
        const weightG  = metaNumber(weight);   // g
        const depthCm  = metaNumber(depth);    // cm
        const widthCm  = metaNumber(width);    // cm
        const heightCm = metaNumber(height);   // cm

        // 사이즈 값 (cm / inch)
        let dimValue = null;
        if (widthCm != null || depthCm != null || heightCm != null) {
          const wCm = widthCm  != null ? `${formatNum(widthCm, 0)}cm`  : '-';
          const dCm = depthCm  != null ? `${formatNum(depthCm, 0)}cm`  : '-';
          const hCm = heightCm != null ? `${formatNum(heightCm, 0)}cm` : '-';

          const wIn = widthCm  != null ? `${formatNum(cmToInch(widthCm), 1)}"`  : '-';
          const dIn = depthCm  != null ? `${formatNum(cmToInch(depthCm), 1)}"`  : '-';
          const hIn = heightCm != null ? `${formatNum(cmToInch(heightCm), 1)}"` : '-';

          const dimCmStr = `${wCm} × ${dCm} × ${hCm}`;
          const hasInch  = (wIn !== '-' || dIn !== '-' || hIn !== '-');
          const dimInStr = hasInch ? `${wIn} × ${dIn} × ${hIn}` : null;

          dimValue = dimInStr ? `${dimCmStr} (${dimInStr})` : dimCmStr;
        }

        // 무게 값 (kg / lb)
        let weightValue = null;
        if (weightG != null) {
          const kg = formatNum(gramsToKg(weightG), 1);
          const lb = formatNum(gramsToLb(weightG), 1);
          weightValue = `${kg} kg (${lb} lb)`;
        }

        // 품질은 메인 정보 테이블 안에 노출
        if (product_quality) {
          htmlContent += `
            <tr>
              <th style="white-space: nowrap;">${T.QUALITY}</th>
              <td>${product_quality}</td>
            </tr>`;
        }

        // 규격(사이즈/무게)이 하나라도 있으면, 별도의 "제품 규격" 테이블 생성
        if (dimValue || weightValue) {
          let specsRows = '';

          if (dimValue) {
            specsRows += `
              <tr>
                <th>${T.DIM_LABEL}</th>
                <td>${dimValue}</td>
              </tr>`;
          }

          if (weightValue) {
            specsRows += `
              <tr>
                <th>${T.WEIGHT_LABEL}</th>
                <td>${weightValue}</td>
              </tr>`;
          }

          specsHtml =
            '<div class="variant-specs-wrapper">' +
              `<div class="variant-specs-heading">${T.SPECS}</div>` +
              '<table class="variant-specs-table">' +
                '<tbody>' +
                  specsRows +
                '</tbody>' +
              '</table>' +
            '</div>';
        }
      }

      htmlContent += '</table>';

      // 제품 규격 테이블 추가
      if (specsHtml) {
        htmlContent += specsHtml;
      }

      variantInfoContainer.innerHTML = htmlContent;

            // ✅ 여기 추가: 변형 바뀔 때마다 Upholstery도 같이 갱신
      if (upholsteryController && selectedVariant) {
        upholsteryController.updateForVariant(selectedVariant);
      }
    }


    // Dawn 변형 변경 이벤트 구독 (✅ 1개만 유지)
    if (window.subscribe && window.PUB_SUB_EVENTS?.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        requestAnimationFrame(() => {
          const matched =
            window.productData.variants.find(v => String(v.id) === String(data.variant.id))
            || window.productData.variants[0];

          updateVariantInfo(matched);
        });
      });
    }


    function getCurrentVariantIdFromForm() {
      const input = document.querySelector('form[action*="/cart/add"] input[name="id"]');
      return input ? String(input.value) : null;
    }
    // 현재 폼의 변형 id로 렌더
    function renderByCurrentId() {
      const id = getCurrentVariantIdFromForm();
      const v = window.productData.variants.find(v => String(v.id) === id) || window.productData.variants[0];
      updateVariantInfo(v);
    }



    if (hasVariants) {
      const radioButtons = variantRadios.querySelectorAll('input[type="radio"]');
      radioButtons.forEach(function (radioButton) {
        radioButton.addEventListener('change', function () {
          const selectedOptions = Array.from(radioButtons)
            .filter(radio => radio.checked)
            .map(radio => radio.value);

          const selectedVariant = window.productData.variants.find(variant => {
            const vOpts = [variant.option1, variant.option2, variant.option3].filter(Boolean);
            return vOpts.every((opt, i) => opt === (selectedOptions[i] || null));
          });

          updateVariantInfo(selectedVariant);
        });
      });

      const initialOptions = Array.from(radioButtons)
        .filter(radio => radio.checked)
        .map(radio => radio.value);

      const initialVariant = window.productData.variants.find(variant => {
        const vOpts = [variant.option1, variant.option2, variant.option3].filter(Boolean);
        return vOpts.every((opt, i) => opt === (initialOptions[i] || null));
      });

      updateVariantInfo(initialVariant);
    } else {
      const firstVariant = window.productData.variants[0];
      updateVariantInfo(firstVariant);
    }
    
  });

  console.log("JavaScript is running");
}
// 상품 상세페이지 내용 업데이트 250103 alex (i18n 적용) end



function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

class SectionId {
  static #separator = '__';

  // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section id (e.g. 'template--22224696705326')
  static parseId(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[0];
  }

  // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section name (e.g. 'main')
  static parseSectionName(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[1];
  }

  // for a section id (e.g. 'template--22224696705326') and a section name (e.g. 'recommended-products'), return a qualified section id (e.g. 'template--22224696705326__recommended-products')
  static getIdForSection(sectionId, sectionName) {
    return `${sectionId}${SectionId.#separator}${sectionName}`;
  }
}

class HTMLUpdateUtility {
  /**
   * Used to swap an HTML node with a new node.
   * The new node is inserted as a previous sibling to the old node, the old node is hidden, and then the old node is removed.
   *
   * The function currently uses a double buffer approach, but this should be replaced by a view transition once it is more widely supported https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API
   */
  static viewTransition(oldNode, newContent, preProcessCallbacks = [], postProcessCallbacks = []) {
    preProcessCallbacks?.forEach((callback) => callback(newContent));

    const newNodeWrapper = document.createElement('div');
    HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
    const newNode = newNodeWrapper.firstChild;

    // dedupe IDs
    const uniqueKey = Date.now();
    oldNode.querySelectorAll('[id], [form]').forEach((element) => {
      element.id && (element.id = `${element.id}-${uniqueKey}`);
      element.form && element.setAttribute('form', `${element.form.getAttribute('id')}-${uniqueKey}`);
    });

    oldNode.parentNode.insertBefore(newNode, oldNode);
    oldNode.style.display = 'none';

    postProcessCallbacks?.forEach((callback) => callback(newNode));

    setTimeout(() => oldNode.remove(), 500);
  }

  // Sets inner HTML and reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
  static setInnerHTML(element, html) {
    element.innerHTML = html;
    element.querySelectorAll('script').forEach((oldScriptTag) => {
      const newScriptTag = document.createElement('script');
      Array.from(oldScriptTag.attributes).forEach((attribute) => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    if (event.target.name === 'plus') {
      if (parseInt(this.input.dataset.min) > parseInt(this.input.step) && this.input.value == 0) {
        this.input.value = this.input.dataset.min;
      } else {
        this.input.stepUp();
      }
    } else {
      this.input.stepDown();
    }

    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

    if (this.input.dataset.min === previousValue && event.target.name === 'minus') {
      this.input.value = parseInt(this.input.min);
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', parseInt(value) <= parseInt(this.input.min));
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);


// ===============================
// TRDST 가격 포맷 + 툴팁 초기화
// ===============================
(function () {
  // 숫자 콤마 포맷팅
  function trdstFormatPriceNumbers(root) {
    root = root || document;
    var els = root.querySelectorAll('.js-ensure-commas');
    if (!els || !els.length) return;

    els.forEach(function (el) {
      var html = el.innerHTML;
      // 이미 콤마가 있으면 건너뜀
      if (/,/.test(html)) return;

      el.innerHTML = html.replace(/(\d[\d\.]*)/g, function (match) {
        var parts = match.split('.');
        var intPart = parts[0];
        var decPart = parts.length > 1 ? parts.slice(1).join('') : '';

        intPart = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

        return decPart ? intPart + '.' + decPart : intPart;
      });
    });
  }

  // 툴팁 델리게이션 (document에 단 한 번만 바인딩)
  function trdstBindPriceTooltipDelegation() {
    if (window.__trdstPriceTooltipInitialized) return;
    window.__trdstPriceTooltipInitialized = true;

    document.addEventListener('click', function (event) {
      var btn = event.target.closest('.trdst-price-tooltip-btn');
      var allTooltips = document.querySelectorAll('.trdst-price-tooltip');

      if (btn) {
        event.preventDefault();
        event.stopPropagation();

        var root = btn.closest('.trdst-price-tooltip-root');
        if (!root) return;

        var tooltip = root.querySelector('.trdst-price-tooltip');
        if (!tooltip) return;

        var isOpen = tooltip.classList.contains('trdst-price-tooltip--visible');

        // 다른 카드 툴팁은 모두 닫기
        allTooltips.forEach(function (el) {
          el.classList.remove('trdst-price-tooltip--visible');
        });

        if (!isOpen) {
          tooltip.classList.add('trdst-price-tooltip--visible');
        }
        return;
      }

      // 버튼 외부 클릭 시 모든 툴팁 닫기
      if (allTooltips && allTooltips.length) {
        allTooltips.forEach(function (el) {
          el.classList.remove('trdst-price-tooltip--visible');
        });
      }
    });
  }

  // 외부에서 쓸 공개 함수 (root 기준으로 초기화)
  window.trdstInitPrices = function (root) {
    root = root || document;
    console.log('[TRDST] init prices for', root); // 🔍 디버그 로그
    trdstFormatPriceNumbers(root);
    trdstBindPriceTooltipDelegation();
  };

  // 첫 로딩 시 전체 한 번 초기화
  document.addEventListener('DOMContentLoaded', function () {
    if (window.trdstInitPrices) {
      window.trdstInitPrices(document);
    }
  });
})();

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}


function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll(
      'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)'
    ).forEach((button) => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    this.dataset.section = this.closest('.shopify-section').id.replace('shopify-section-', '');
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class BulkModal extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      if (this.innerHTML.trim() === '') {
        const productUrl = this.dataset.url.split('?')[0];
        fetch(`${productUrl}?section_id=bulk-quick-order-list`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const sourceQty = html.querySelector('.quick-order-list-container').parentNode;
            this.innerHTML = sourceQty.innerHTML;
          })
          .catch((e) => {
            console.error(e);
          });
      }
    };

    new IntersectionObserver(handleIntersection.bind(this)).observe(
      document.querySelector(`#QuickBulk-${this.dataset.productId}-${this.dataset.sectionId}`)
    );
  }
}

customElements.define('bulk-modal', BulkModal);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }

      // Workaround for safari iframe bug
      const formerStyle = deferredElement.getAttribute('style');
      deferredElement.setAttribute('style', 'display: block;');
      window.setTimeout(() => {
        deferredElement.setAttribute('style', formerStyle);
      }, 0);
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener('change', (event) => {
      const target = this.getInputForEventTarget(event.target);
      this.updateSelectionMetadata(event);

      publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
        data: {
          event,
          target,
          selectedOptionValues: this.selectedOptionValues,
        },
      });
    });
  }

  updateSelectionMetadata({ target }) {
    const { value, tagName } = target;

    if (tagName === 'SELECT' && target.selectedOptions.length) {
      Array.from(target.options)
        .find((option) => option.getAttribute('selected'))
        .removeAttribute('selected');
      target.selectedOptions[0].setAttribute('selected', 'selected');

      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = target
        .closest('.product-form__input')
        .querySelector('[data-selected-value] > .swatch');
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
        selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
      } else {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
        selectedDropdownSwatchValue.classList.add('swatch--unavailable');
      }

      selectedDropdownSwatchValue.style.setProperty(
        '--swatch-focal-point',
        target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
      );
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  getInputForEventTarget(target) {
    return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
  }

  get selectedOptionValues() {
    return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
      ({ dataset }) => dataset.optionValueId
    );
  }
}

customElements.define('variant-selects', VariantSelects);

class ProductRecommendations extends HTMLElement {
  observer = undefined;

  constructor() {
    super();
  }

  connectedCallback() {
    this.initializeRecommendations(this.dataset.productId);
  }

  initializeRecommendations(productId) {
    this.observer?.unobserve(this);
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.loadRecommendations(productId);
      },
      { rootMargin: '0px 0px 400px 0px' }
    );
    this.observer.observe(this);
  }

  loadRecommendations(productId) {
    fetch(`${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations');

        if (recommendations?.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }

        if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
          this.remove();
        }

        if (html.querySelector('.grid__item')) {
          this.classList.add('product-recommendations--loaded');
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }
}

customElements.define('product-recommendations', ProductRecommendations);

class AccountIcon extends HTMLElement {
  constructor() {
    super();

    this.icon = this.querySelector('.icon');
  }

  connectedCallback() {
    document.addEventListener('storefront:signincompleted', this.handleStorefrontSignInCompleted.bind(this));
  }

  handleStorefrontSignInCompleted(event) {
    if (event?.detail?.avatar) {
      this.icon?.replaceWith(event.detail.avatar.cloneNode());
    }
  }
}

customElements.define('account-icon', AccountIcon);

class BulkAdd extends HTMLElement {
  static ASYNC_REQUEST_DELAY = 250;

  constructor() {
    super();
    this.queue = [];
    this.setRequestStarted(false);
    this.ids = [];
  }

  startQueue(id, quantity) {
    this.queue.push({ id, quantity });

    const interval = setInterval(() => {
      if (this.queue.length > 0) {
        if (!this.requestStarted) {
          this.sendRequest(this.queue);
        }
      } else {
        clearInterval(interval);
      }
    }, BulkAdd.ASYNC_REQUEST_DELAY);
  }

  sendRequest(queue) {
    this.setRequestStarted(true);
    const items = {};

    queue.forEach((queueItem) => {
      items[parseInt(queueItem.id)] = queueItem.quantity;
    });
    this.queue = this.queue.filter((queueElement) => !queue.includes(queueElement));

    this.updateMultipleQty(items);
  }

  setRequestStarted(requestStarted) {
    this._requestStarted = requestStarted;
  }

  get requestStarted() {
    return this._requestStarted;
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;

    if (inputValue < event.target.dataset.min) {
      this.setValidity(event, index, window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min));
    } else if (inputValue > parseInt(event.target.max)) {
      this.setValidity(event, index, window.quickOrderListStrings.max_error.replace('[max]', event.target.max));
    } else if (inputValue % parseInt(event.target.step) != 0) {
      this.setValidity(event, index, window.quickOrderListStrings.step_error.replace('[step]', event.target.step));
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      event.target.setAttribute('value', inputValue);
      this.startQueue(index, inputValue);
    }
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }
}

if (!customElements.get('bulk-add')) {
  customElements.define('bulk-add', BulkAdd);
}

class CartPerformance {
  static #metric_prefix = "cart-performance"

  static createStartingMarker(benchmarkName) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    return performance.mark(`${metricName}:start`);
  }

  static measureFromEvent(benchmarkName, event) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    const startMarker = performance.mark(`${metricName}:start`, {
      startTime: event.timeStamp
    });

    const endMarker = performance.mark(`${metricName}:end`);

    performance.measure(
      metricName,
      `${metricName}:start`,
      `${metricName}:end`
    );
  }

  static measureFromMarker(benchmarkName, startMarker) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    const endMarker = performance.mark(`${metricName}:end`);

    performance.measure(
      metricName,
      startMarker.name,
      `${metricName}:end`
    );
  }

  static measure(benchmarkName, callback) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    const startMarker = performance.mark(`${metricName}:start`);

    callback();

    const endMarker = performance.mark(`${metricName}:end`);

    performance.measure(
      metricName,
      `${metricName}:start`,
      `${metricName}:end`
    );
  }
}
